import { useGetUserQuery } from "../api";
import LoadingTakeover from "../components/buffers/LoadingTakeover";


const withUser = (WrappedContent) => {

    return function WithUserComponent(props) {
        const { data, loading, error } = useGetUserQuery();

        if (loading) {
            return (
                <LoadingTakeover />
            ) 
        }  
        if (error) return <div>Error loading user.</div>;
            
        return <WrappedContent {...props} userData={data.data}/>;
    };
};

export default withUser;